import { useSetWaiterError } from "@/shared/atoms/useWaiterError";
import useCommon from "@/shared/hooks/useCommon";
import { useState } from "react";
import useSendWaiterCordQuery from "./useSendWaiterCordQuery";

const GEOLOCATION_OPTIONS: PositionOptions = { timeout: 15000, maximumAge: 0 };

const useSendWaiterCord = () => {
  const t = useCommon();
  const mutate = useSendWaiterCordQuery();
  const setWaiterError = useSetWaiterError();
  const [isLocating, setIsLocating] = useState(false);

  const check = () => {
    if (!navigator.geolocation) {
      setWaiterError({ code: 0, message: "Geolocation is not supported" });
      return;
    }

    setIsLocating(true);
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        setIsLocating(false);
        mutate
          .mutateAsync({
            lat: pos.coords.latitude.toString(),
            lng: pos.coords.longitude.toString(),
          })
          .then(() => setWaiterError(null))
          .catch(() => {
            setWaiterError({ code: 403, message: t("waiterNotInBranch") });
          });
      },
      (err) => {
        setIsLocating(false);
        setWaiterError({ code: err.code, message: err.message });
      },
      GEOLOCATION_OPTIONS
    );
  };

  return { check, isPending: isLocating || mutate.isPending };
};

export default useSendWaiterCord;
